import { Component, Input, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-purification-card',
    templateUrl: './purification-card.component.html',
    styleUrls: ['./purification-card.component.scss'],
    standalone: false
})
export class PurificationCardComponent implements OnInit {
  @Input() stockName!: string;
  @Input() stockTicker!: string;
  @Input() complianceStatus!: string
  isBrowser: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
  }

}
